module.exports = __webpack_public_path__ + "media/images/flags/1x1/mtq-0bf952d8c10f2affd2b639eb9d39aa87.svg";